import { db } from "../Config";

// Verifica si la empresa tiene horarios de especialistas configurados
export const tieneHorariosConfigurados = async (empresaId) => {
  try {
    const snapshot = await db
      .collection("horariosEspecialistas")
      .where("empresaId", "==", empresaId)
      .limit(1)
      .get();
    return !snapshot.empty;
  } catch (error) {
    console.error("Error al verificar horarios de especialistas:", error);
    throw error;
  }
};


// Agrega un nuevo horario de especialista
export const addHorarioEspecialista = (idEmpresa, horarioData) => {
  return async function (dispatch, getState) {
    try {
      // Agregar el nuevo horario
      const nuevoHorario = {
        ...horarioData,
        empresaId: idEmpresa,
        createdAt: new Date(),  // Fecha local como respaldo
        updatedAt: new Date(),  // Fecha local como respaldo
        duracionCitaMin: parseInt(horarioData.duracionCitaMin) || 30,
      };

      // Agregar documento con ID auto-generado
      const docRef = await db.collection('horariosEspecialistas').add(nuevoHorario);
      
      return docRef.id;
    } catch (error) {
      console.error("Error al guardar horario de especialista:", error);
      throw error;
    }
  };
};

// Obtiene los horarios por empresa
export const fetchHorariosByEmpresa = async (empresaId) => {
  try {
    const snapshot = await db
      .collection("horariosEspecialistas")
      .where("empresaId", "==", empresaId)
      .get();
    
    let horarios = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    
    // Ordenar los resultados en JavaScript después de obtenerlos
    horarios.sort((a, b) => {
      // Asegurarse de que sean objetos Date para comparación correcta
      const dateA = a.createdAt instanceof Date ? a.createdAt : new Date(a.createdAt);
      const dateB = b.createdAt instanceof Date ? b.createdAt : new Date(b.createdAt);
      return dateB - dateA; // Orden descendente
    });
    
    return horarios;
  } catch (error) {
    console.error("Error al obtener horarios de especialistas:", error);
    throw error;
  }
};



// Elimina un horario de especialista
export const deleteHorarioEspecialista = (id, idEmpresa) => {
  return async (dispatch) => {
    try {
      // 1. Validación básica de los parámetros
      if (!id || typeof id !== "string") {
        throw new Error("ID de horario inválido");
      }
      if (!idEmpresa || typeof idEmpresa !== "string") {
        throw new Error("ID de empresa inválido");
      }

      // 2. Obtener referencia al documento
      const docRef = db.collection('horariosEspecialistas').doc(id);
      
      // 3. Verificar existencia del documento
      const docSnapshot = await docRef.get();
      if (!docSnapshot.exists) {
        throw new Error("El horario de especialista no existe en la base de datos");
      }

      // 4. Verificar que el empresaId coincida con idEmpresa
      const horarioData = docSnapshot.data();
      if (horarioData.empresaId !== idEmpresa) {
        throw new Error("No se puede eliminar este horario porque no pertenece a la empresa especificada");
      }

      // 5. Ejecutar la eliminación
      await docRef.delete();

      // 6. Actualizar el estado global
      dispatch({
        type: 'HORARIO_ESPECIALISTA_DELETED',
        payload: id
      });

      // 7. Retornar el ID para posibles usos posteriores
      return id;

    } catch (error) {
      console.error("Error en deleteHorarioEspecialista:", error);
      throw error; // Propagar el error para manejo superior
    }
  };
};

// Guarda o actualiza un horario de especialista usando el ID específico
export const updateHorarioEmpresa = async (horarioId, horarioData) => {
  try {
    const horarioRef = db.collection("horariosEspecialistas").doc(horarioId);
    //const doc = await horarioRef.get();

    //if (doc.exists) {
      // Actualizar si ya existe
      await horarioRef.update({
        ...horarioData,
      });
    //} 

    return true;
  } catch (err) {
    throw err;
  }
};

// Guarda o actualiza un horario de especialista usando el ID específico
export const addHorarioEmpresa = async ( horarioData) => {
  try {
    
    const horarioRef = db.collection("horariosEspecialistas").doc();
    const doc = await horarioRef.get();

   
      // Crear nuevo registro si no existe
      await horarioRef.set({
        ...horarioData,
      });
    
    return horarioRef.id;
  } catch (err) {
    throw err;
  }
};
export const getHorariosByEspecialistaAndByEmpresa = async (especialistaId, empresaId) => {
  try {
    // Primero intentamos obtener el horario con el empresa_id proporcionado
    // const horarioRef = db.collection("horariosEspecialistas").where("empresaId", "==", empresaId).where("especialistaId","==", especialistaId);
    // const doc = await horarioRef.get();


    const snapshot = await db
      .collection("horariosEspecialistas")
      .where("empresaId", "==", empresaId)
      .where("especialistaId","==", especialistaId)
      .get();
    
    let horarios = snapshot?.docs?.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    // Si existe, lo devolve en esetmos
    if (horarios.length>0) {
      
      return horarios[0]
    } else {
      // Si no existe, buscamos el horario con empresaId = 0 (valor por defecto) usando where
      const defaultHorarioRef = db.collection("horariosEspecialistas")
                                .where("empresaId", "==", "0");
      const snapshot = await defaultHorarioRef.get();
      
      if (!snapshot.empty) {
        const defaultDoc = snapshot.docs[0];
        return {
          id: defaultDoc.id,
          ...defaultDoc.data()
        };
      }
      
      // Si ninguno existe, lanzamos un error
      throw new Error(`No se encontró el horario con ID: ${empresaId} ni el horario predeterminado (empresaId: 0)`);
    }
    
  } catch (error) {
    throw new Error(`Error al obtener horario: ${error.message}`);
  }
};